class Session {
    ROLE = Object.freeze({
      customer: 'WEB_USER',
      admin: 'WEB_ADMIN',
    });

    constructor(json) {
      const {
        role,
        firstName,
        lastName,
        companyBusinessId,
        isSubcontractor,
      } = json || {};

      this.role = Object.values(this.ROLE).find((r) => (r === role));
      // this.role = 'WEB_ADMIN';
      if (!this.isAuthenticated) {
        return;
      }
      this.firstName = firstName;
      this.lastName = lastName;
      this.companyBusinessId = companyBusinessId;
      this.isSubcontractor = isSubcontractor;
    }

    get isAuthenticated() {
      return !!this.role;
    }

    get isAdmin() {
      return this.role === this.ROLE.admin;
    }

    get isNormalUser() {
      return this.role === this.ROLE.customer;
    }
}

export default Session;
